import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Input, CustomSelect, Textarea, Checkbox, InputWrapper} from '../../../Components';
import { componentStatus } from '../../../Constants/Constants';

export function EditComponentGroup({
	onSuccess = () => {}
}) {

	const { page_id , component_id} = useParams();
	const navigate = useNavigate();
    const {user , org} = useSelector((state) => state.auth)

	const [componentData, setComponentData] = useState({})
	const [formData, setFormData] = useState({
		name: "",
		description: "",
		display_chart : false,
		
		 
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
	})
	const [componentGroups, setComponentGroups] = useState([])
	const [isLoadingData, setIsLoadingData] = useState(true)
	const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)

	useEffect( () => {
		
		async function fetchData() {

            // ! CHECK THE ACCESS 
            if(org?.statuspages?.findIndex(x => x.id === page_id) < 0 ) {
                navigate(`/pages`)
                return
            }
			
			await getComponentData();
		 

		}
		fetchData();
	}, [])

	/**
	 * 
	 * @returns 
	 */
	const getComponentData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingData(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/components/${component_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setComponentData(data)
					setFormData( (prevState) => ({
						...prevState,
						name: data?.name,
						description: data?.description,
						display_chart : data?.display_chart,
						
					}
					))

					setIsLoadingData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setComponentData({})
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingData(false)
			}

		})
	} 

	 
	/**
	 * SAVE COMPONENT 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoadingSubmit(true)
			setFormValidation((prevState) => ({
				...prevState,
				name: (formData.name === '') ? 'Invalid name' : '',
			}))

			if(formValidation.name !=='' ){

				toast.error("Please complete all required fields") 
				setIsLoadingSubmit(false)

				return 
			}

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { 
					name : formData?.name,
					description : formData?.description,
					display_chart : formData?.display_chart,
				}

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/componentgroups/${component_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoadingSubmit(false)

					toast.success('Your component group has been successfully edited')  

					onSuccess(data)

					onCloseForm();
		
					resolve(data.data) 
		
				})
				.catch(error => {

					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingSubmit(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
                            __error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
                    reject(__error)
				})
			}else{
				setIsLoadingSubmit(false)
				toast.error(`Something went wrong, please try again later.`)  
			}


		})

	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		switch(e.target.name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? 'Invalid name' : ''
				}))
				
				break;
			 
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};
 

	 
	const onCloseForm = () => {
		navigate(`/pages/${page_id}/components`)	
	}

	return (
        <>
            <Helmet>
                <title>{`Edit component group - ${process.env.REACT_APP_APP_NAME}`}</title>
            </Helmet>
            <form onSubmit={onSubmit}>
                {
                    isLoadingData
                    ? 'Loading..'
                    : (
                        <>
                        <Input
                            placeholder="Component name"
                            label="Component name"
                            required
                            mb={15}
                            name="name"
                            onChange={onChange}
                            error={formValidation?.name}
                            value={formData?.name}
                        />
                        <Textarea
                            placeholder="Give a helpful description of what this component does. "
                            label="Description"
                            mb={15}
                            name="description"
                            onChange={onChange}
                            value={formData?.description ?? ''}
                            rows={4}
                            />
                        {/* <div label="Display uptime" mb={15}>
                            <Checkbox 
                                name="display_chart"
                                label="Display the historical status" 
                                onChange={onChange}
                                checked={formData?.display_chart} />
                        </div> */}
                        
                        
                        </>
                    )
                }
                <div className="field-group submit-fields-group"   >
                    <Button className="" color="gray" variant="default" onClick={onCloseForm} >Back</Button>
                    <Button className="ml-10" onClick={onSubmit} loading={isLoadingSubmit}>Update component group</Button>
                </div>
            </form>
        </>
	);
}
